export default __webpack_public_path__ + "static/media/calculate.4e196016.svg";